import { Form, Formik } from 'formik';
import { InvitarNegocioARegistroForm } from './InvitarNegocioARegistroForm';
import { SchemaInvitarNegocio } from './SchemaInvitarNegocio';
import { AlertaError, AlertaExito } from 'utils/Alertas';
import Heading from 'components/design-system/Heading/Heading';
import Text from 'components/design-system/Text/Text';
import gruposService from 'services/grupos';

export const InvitarNegocioARegistro = () => {
  return (
    <div className="bg-white rounded p-5 shadow-md mb-5">
      <Heading type="h4" className="mb-0">
        Invitar a un negocio a registrarse
      </Heading>
      <Text className="mb-4">
        Si el negocio no está registrado en la plataforma puedes enviar una
        notificación para que se una a la plataforma
      </Text>
      <Formik
        initialValues={{
          emails: []
        }}
        validationSchema={SchemaInvitarNegocio}
        validateOnMount={true}
        onSubmit={async (values, { resetForm }) => {
          try {
            const params = {
              sucursales: null,
              empresa: null,
              grupo: null,
              correosElectronicos: values.emails
            };
            await gruposService.solicitarAdministracion(params).then(res => {
              if (res.status === 200 && !res.data.error) {
                AlertaExito('Se ha enviado la invitación correctamente');
              }
            });
          } catch (error) {
            AlertaError('Ha ocurrido un error en el envío de la solicitud');
          } finally {
            resetForm();
          }
        }}
      >
        {({ values, isSubmitting, setFieldValue, errors, touched }) => (
          <Form id="invitar-a-registro" onChange={event => {}}>
            <InvitarNegocioARegistroForm
              isSubmitting={isSubmitting}
              setFieldValue={setFieldValue}
              values={values}
              errors={errors}
              touched={touched}
            />
          </Form>
        )}
      </Formik>
    </div>
  );
};
